import {
    MonitoringQueries,
    ServiceMonitoringProps,
} from '@/modules/Service/types'
import React, { useState } from 'react'
import Domains from './Domains'
import Quota from './Quota'
import Header from '../../shared/Header'
import dayjs from 'dayjs'

const today = dayjs()

const Monitoring: React.FC<ServiceMonitoringProps> = ({ service }) => {
    const [queries, setQueries] = useState<MonitoringQueries>({
        gte: today.startOf('month').format('YYYY-MM-DD'),
        lte: today.endOf('month').format('YYYY-MM-DD'),
        range: '30d',
    })
    return (
        <>
            <Header analyticQueries={queries} setAnalyticQueries={setQueries} />
            <Quota service={service} queries={queries} />
            <Domains service={service} />
        </>
    )
}

export default Monitoring
